
import { format, isSameDay } from "date-fns";
import { es } from "date-fns/locale";

interface CalendarDayHeadersProps {
  days: Date[];
  cellWidth: number;
  labelColumnWidth: number;
}

const CalendarDayHeaders = ({ days, cellWidth }: CalendarDayHeadersProps) => {
  const today = new Date();
  
  console.log('🔧 CalendarDayHeaders render (3 months):', { daysCount: days.length, cellWidth });

  return (
    <div className="flex bg-white border-b h-10">
      {days.map(day => (
        <div
          key={day.toISOString()}
          style={{ 
            width: cellWidth,
            minWidth: cellWidth,
            maxWidth: cellWidth,
            height: 40
          }}
          className="flex flex-col items-center justify-center border-r bg-gray-50"
        >
          <span className="text-[10px] text-gray-400 uppercase leading-none">
            {format(day, "EEE", { locale: es })}
          </span>
          <span
            className="text-xs font-bold leading-none mt-1"
            style={{
              color: isSameDay(day, today) ? "#2563eb" : "#374151",
            }}
          >
            {format(day, "d")}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CalendarDayHeaders;
